import { render, staticRenderFns } from "./OtherSkill.vue?vue&type=template&id=1b5665f1&"
import script from "./OtherSkill.vue?vue&type=script&lang=js&"
export * from "./OtherSkill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports